// extracted by mini-css-extract-plugin
module.exports = {"filtersMenu":"FiltersMenu_filtersMenu__yEZQe","category":"FiltersMenu_category__tD_iz","introduction":"FiltersMenu_introduction__YLHSc"};